( function ( windowObject, documentObject ) {
	'use strict';

	if ( ! windowObject || ! documentObject || ! windowObject.TomSelect ) {
		return;
	}

	const TomSelectClass = windowObject.TomSelect;

	function normalizeTargets( selector ) {
		if ( ! selector ) {
			return Array.from(
				documentObject.querySelectorAll( '.select2-init-field' )
			);
		}

		if ( typeof selector === 'string' ) {
			return Array.from( documentObject.querySelectorAll( selector ) );
		}

		if ( selector instanceof windowObject.Element ) {
			return [ selector ];
		}

		if (
			selector instanceof windowObject.NodeList ||
			Array.isArray( selector )
		) {
			return Array.from( selector ).filter( function ( element ) {
				return element instanceof windowObject.Element;
			} );
		}

		return [];
	}

	function escapeHtml( value ) {
		return String( value || '' )
			.replaceAll( '&', '&amp;' )
			.replaceAll( '<', '&lt;' )
			.replaceAll( '>', '&gt;' )
			.replaceAll( '"', '&quot;' )
			.replaceAll( "'", '&#039;' );
	}

	function createPlugins( options ) {
		const plugins = {
			dropdown_input: {},
		};

		if ( options && options.allowClear === false ) {
			return plugins;
		}

		plugins.clear_button = {
			title: '',
		};

		return plugins;
	}

	function wrapCallback( existingCallback, nextCallback ) {
		if ( typeof existingCallback === 'function' ) {
			return function () {
				existingCallback.apply( this, arguments );
				nextCallback.apply( this, arguments );
			};
		}

		return nextCallback;
	}

	function hasRealSingleValue( instance ) {
		if ( ! instance || typeof instance.getValue !== 'function' ) {
			return false;
		}

		const value = instance.getValue();

		if ( Array.isArray( value ) ) {
			return value.some( function ( item ) {
				return String( item || '' ).length > 0;
			} );
		}

		return String( value || '' ).length > 0;
	}

	function getCanonicalPlaceholder( instance ) {
		if ( ! instance || ! instance.settings ) {
			return '';
		}

		if ( instance.settings.__ssPlaceholder === undefined ) {
			instance.settings.__ssPlaceholder = String(
				instance.settings.placeholder || ''
			);
		}

		return instance.settings.__ssPlaceholder;
	}

	function applyPlaceholderState( instance, options ) {
		if ( ! instance || ! instance.settings || ! instance.control_input ) {
			return;
		}

		if ( Number( instance.settings.maxItems ) !== 1 ) {
			return;
		}

		const config = options || {};
		const placeholder = getCanonicalPlaceholder( instance );

		if ( ! placeholder ) {
			return;
		}

		let shouldShowPlaceholder = ! hasRealSingleValue( instance );

		if ( config.forceVisible ) {
			shouldShowPlaceholder = true;
		} else if ( shouldShowPlaceholder && ( instance.isFocused || instance.isOpen ) ) {
			shouldShowPlaceholder = false;
		}

		instance.settings.placeholder = shouldShowPlaceholder ? placeholder : '';

		if ( typeof instance.inputState === 'function' ) {
			instance.inputState();
			return;
		}

		instance.control_input.setAttribute(
			'placeholder',
			instance.settings.placeholder
		);
	}

	function applyRealValueState( instance ) {
		if ( ! instance || ! instance.wrapper || ! instance.settings ) {
			return;
		}

		if ( Number( instance.settings.maxItems ) !== 1 ) {
			return;
		}

		instance.wrapper.classList.toggle(
			'has-real-value',
			hasRealSingleValue( instance )
		);
	}

	function withSingleSelectState( config ) {
		const nextConfig = Object.assign( {}, config );

		nextConfig.onInitialize = wrapCallback(
			config.onInitialize,
			function () {
				getCanonicalPlaceholder( this );
				applyRealValueState( this );
				applyPlaceholderState( this );
			}
		);
		nextConfig.onChange = wrapCallback( config.onChange, function () {
			applyRealValueState( this );
			applyPlaceholderState( this );
		} );
		nextConfig.onItemAdd = wrapCallback( config.onItemAdd, function () {
			applyRealValueState( this );
			applyPlaceholderState( this );
		} );
		nextConfig.onItemRemove = wrapCallback( config.onItemRemove, function () {
			applyRealValueState( this );
			applyPlaceholderState( this );
		} );
		nextConfig.onClear = wrapCallback( config.onClear, function () {
			applyRealValueState( this );
			applyPlaceholderState( this, { forceVisible: true } );
		} );
		nextConfig.onFocus = wrapCallback( config.onFocus, function () {
			applyPlaceholderState( this );
		} );
		nextConfig.onBlur = wrapCallback( config.onBlur, function () {
			applyPlaceholderState( this );
		} );
		nextConfig.onDropdownOpen = wrapCallback(
			config.onDropdownOpen,
			function () {
				applyPlaceholderState( this );
			}
		);
		nextConfig.onDropdownClose = wrapCallback(
			config.onDropdownClose,
			function () {
				applyPlaceholderState( this );
			}
		);
		nextConfig.onType = wrapCallback( config.onType, function () {
			applyPlaceholderState( this );
		} );

		return nextConfig;
	}

	function buildSimpleConfig( element, options ) {
		const overrides = options || {};

		return withSingleSelectState(
			Object.assign(
				{
					create: false,
					maxItems: 1,
					allowEmptyOption: true,
					plugins: createPlugins( overrides ),
					placeholder:
						overrides.placeholder !== undefined
							? overrides.placeholder
							: element.dataset.placeholder || '',
					searchField: [ 'text' ],
					render: {
						no_results() {
							return '<div class="no-results">Не знайдено</div>';
						},
					},
				},
				overrides,
				{
					plugins:
						overrides.plugins !== undefined
							? overrides.plugins
							: createPlugins( overrides ),
				}
			)
		);
	}

	function getInstance( element ) {
		if ( ! element || ! element.tomselect ) {
			return null;
		}

		return element.tomselect;
	}

	function initSimpleSelect2( selector, options ) {
		normalizeTargets( selector ).forEach( function ( element ) {
			if ( getInstance( element ) ) {
				return;
			}

			new TomSelectClass(
				element,
				buildSimpleConfig( element, options )
			);
		} );
	}

	function normalizeBakeryResults( response ) {
		const items = Array.isArray( response && response.results )
			? response.results
			: [];

		return items.map( function ( item ) {
			const text = item && item.text ? String( item.text ) : '';

			return {
				value: text,
				text,
				bakeryId: Number( item && item.id ? item.id : 0 ),
				city: item && item.city ? String( item.city ) : '',
				isFeatured: Boolean( item && item.isFeatured ),
			};
		} );
	}

	function buildBakeryOptionMarkup( bakery ) {
		const cityMarkup = bakery.city
			? '<span class="ss-select__city">' +
			  escapeHtml( bakery.city ) +
			  '</span>'
			: '';
		const featuredMarkup = bakery.isFeatured
			? '<span class="ss-select__badge">Рекомендовано</span>'
			: '';

		return (
			'<div class="ss-select__option">' +
			'<span class="ss-select__label">' +
			escapeHtml( bakery.text || bakery.value || '' ) +
			'</span>' +
			cityMarkup +
			featuredMarkup +
			'</div>'
		);
	}

	function trackSearchSelect( item, sourceGroup ) {
		if (
			! item ||
			! windowObject.SweettySpaceAnalytics ||
			! windowObject.SweettySpaceAnalytics.track
		) {
			return;
		}

		windowObject.SweettySpaceAnalytics.track( {
			event_name: 'search_select',
			entity_type: 'bakery',
			entity_id: Number( item.bakeryId || 0 ),
			bakery_id: Number( item.bakeryId || 0 ),
			source_group: sourceGroup || '',
			payload: {
				label: item.text || item.value || '',
			},
		} );
	}

	function initRemoteBakerySelect( selector, config ) {
		const runtimeConfig = config || {};
		const endpoint = runtimeConfig.restUrl || '';
		const token = runtimeConfig.searchToken || '';
		const minInputLength = Number( runtimeConfig.minimumInput || 2 );
		const placeholderText = runtimeConfig.placeholderText || '';
		const sourceGroup = runtimeConfig.sourceGroup || '';

		normalizeTargets( selector ).forEach( function ( element ) {
			if ( getInstance( element ) || ! endpoint ) {
				return;
			}

			new TomSelectClass(
				element,
				Object.assign( buildSimpleConfig( element ), {
					valueField: 'value',
					labelField: 'text',
					searchField: [ 'text', 'city' ],
					loadThrottle: 250,
					placeholder:
						element.dataset.placeholder || placeholderText || '',
					render: {
						option( bakery ) {
							return buildBakeryOptionMarkup( bakery );
						},
						item( bakery ) {
							return (
								'<div>' +
								escapeHtml(
									bakery.text || bakery.value || ''
								) +
								'</div>'
							);
						},
						no_results() {
							return '<div class="no-results">Не знайдено</div>';
						},
						loading() {
							return '<div class="spinner">...</div>';
						},
					},
					shouldLoad( query ) {
						return query.length >= minInputLength;
					},
					load( query, callback ) {
						const requestUrl = new windowObject.URL( endpoint );

						requestUrl.searchParams.set( 'q', query || '' );
						requestUrl.searchParams.set( 'per_page', '20' );
						requestUrl.searchParams.set( 'page', '1' );

						windowObject
							.fetch( requestUrl.toString(), {
								headers: {
									'X-SweettySpace-Search-Token': token,
								},
								credentials: 'same-origin',
							} )
							.then( function ( response ) {
								if ( ! response.ok ) {
									throw new Error( 'Bakery search failed.' );
								}

								return response.json();
							} )
							.then( function ( response ) {
								callback( normalizeBakeryResults( response ) );
							} )
							.catch( function () {
						callback();
							} );
					},
					onItemAdd( value ) {
						const item = this.options[ value ] || null;

						trackSearchSelect( item, sourceGroup );
					},
				} )
			);
		} );
	}

	windowObject.SweettySpaceSelect = Object.assign(
		windowObject.SweettySpaceSelect || {},
		{
			getInstance,
			initSimpleSelect2,
			initRemoteBakerySelect,
		}
	);
} )( window, document );
